import type { Subsidy } from "@daytrip/legacy-models";

import { ModelOperator } from "./ModelOperator";
import type { ModelOperatorOptions } from "./ModelOperatorOptions";

interface SubsidyOperatorOptions extends ModelOperatorOptions<Subsidy, {}, {}> {}

export class SubsidyOperator extends ModelOperator<Subsidy, SubsidyOperatorOptions, {}, {}, {}> {}
